

export const findAndReorderTopTag = (topTagIndex, tags) => {
  const responseTopTag = tags.get(topTagIndex);
  const arrangedTags = tags.splice(topTagIndex, 1).splice(0, 0, responseTopTag);

  return arrangedTags;
};

export const isTopTag = tagName => tagName.toLowerCase() === "top";
